import { Layout, theme } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { getUser, isLogin } from "../Store/Actions/AuthAction";
import { sessionExpired } from "../Store/Actions/GeneralActions";
import { AuthMiddleware } from "../Store/Middlewares/AuthMiddleware";
import Sider from "antd/es/layout/Sider";
import SideMenu from "../components/sideMenu/SideMenu";
import useWindowDimensions from "../hooks/useWindowDimensions";
import styles from "./layoutstyle.module.css";

import CompHeader from "../components/header/Header";
import Storage from "../utills/AsyncStorage";
import ResetPassword from "../screens/Auth/ResetPasswrd";
// import { roles } from "../config/roles";

const { Header, Content, Footer } = Layout;
export const ProtectedLayout = ({ roles }) => {
  const IsLogin = useSelector((state) => state.AuthReducer.isLogin);
  const user = useSelector((state) => state.AuthReducer.user);
  const reset = useSelector((state) => state.AuthReducer.isReset);
  const role = Storage.getERole("@role");
  const redirect_url = Storage.getRedirect_URL("@redirect_url");

  const [collapsed, setCollapsed] = useState(false);
  const [cancelCount, setCancelCount] = useState(0);
  const [isReset, setIsReset] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { height, width } = useWindowDimensions();
  const location = useLocation();

  useEffect(() => {
    const timerId = setTimeout(() => {
      if (reset === true) {
        setIsReset(true);
      }
    }, 5000);

    return () => clearTimeout(timerId);
  }, [cancelCount, reset]);

  const handleCancel = () => {
    setIsReset(false);
    setCancelCount((c) => c + 1);
  };

  if (IsLogin == false) {
    return <Navigate to={redirect_url || "/"} />;
  }
  if (IsLogin == true && roles.includes(role)) {
    return (
      <Layout
        // hasSider
        style={{
          position: "fixed",
          width: "100%",
          backgroundColor: "var(--white-color)",
          paddingTop: width > 768 ? "20px" : "0px",
          height: "100vh",
        }}
      >
        <Content
          style={{
            margin: width > 768 ? "auto" : "0px",
            padding: "10px 20px",
            // minHeight: 650,
            background: "var(--bg-color)",
            height: "85vh",
            overflowY: "scroll",
            minWidth: width > 768 ? "80%" : "100%",
            boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 4px;",
            borderRadius: width > 768 ? "18px" : "0px",
          }}
        >
          <CompHeader
            onBackClick={() => setCollapsed(!collapsed)}
            collapsed={collapsed}
            mainHeader={styles.mainHeader}
          />
          {/* <Box boxClass={styles.contentBox}> */}
          <Outlet />
          {/* </Box> */}
          <ResetPassword open={isReset} setOpen={handleCancel} />
        </Content>
      </Layout>
    );
  }

  return (
    <Layout
      // hasSider
      style={{
        position: "fixed",
        width: "100%",
        backgroundColor: "var(--white-color)",
      }}
    >
      <Sider
        trigger={null}
        collapsible
        width={220}
        collapsed={width > 768 ? collapsed : true}
        style={{
          backgroundColor: "var(--primary-color)",
          overflow: "auto",
          height: "100vh",
          padding: 0,
          overflowX: "hidden",
        }}
      >
        <SideMenu
          collapsed={collapsed}
          onBackClick={() => setCollapsed(!collapsed)}
        />
      </Sider>

      <Layout className="site-layout">
        <CompHeader
          onBackClick={() => setCollapsed(!collapsed)}
          collapsed={collapsed}
        />
        <Content
          style={{
            // margin: "10px 4px",
            padding: "0px 20px",
            // minHeight: 650,
            background: "var(--bg-color)",
            height: "75vh",
            overflowY: "scroll",
          }}
        >
          {/* <Box boxClass={styles.contentBox}> */}
          <Outlet />
          {/* </Box> */}
          <ResetPassword open={isReset} setOpen={handleCancel} />
        </Content>
      </Layout>
    </Layout>
  );
};

export const ProtectedRoute = () => {
  const IsLogin = useSelector((state) => state.AuthReducer.isLogin);
  const redirect_url = Storage.getRedirect_URL("@redirect_url");

  if (IsLogin == false) {
    // navigate('/login');
    return <Navigate to={redirect_url || "/"} />;
  }
  return <Outlet />;
};
